export default __webpack_public_path__ + "ed305b5434865e06ffde7da0d28101af.ttf";